export default __webpack_public_path__ + "static/media/uploadimg3.661b047a.svg";